import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { get } from '../../actions/base'
import { Form } from 'formsy-react'
import { Avatar, Button, Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { MenuItem } from 'material-ui'
import { FormsySelect } from 'formsy-material-ui'
import CancelButton from '../Forms/CancelButton'

class DefaultVisibilityEdit extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      canSubmit: true,
      isDirty: false,
      groups: null,
      groupsLoaded: false,
      users: null,
      usersLoaded: false,
      item: props.item
    }

    //componentWillMount migration start
    //this.setState({ item: this.props.item }) Can't call setState on a component that is not yet mounted.
    //componentWillMount migration end
  }

  // MIGRATED TO componentDidMount and constructor
  // componentWillMount () {
  //   this.fetchGroups()
  //   this.setState({ item: this.props.item })
  // }

  componentDidMount() {
    if (this.state.groupsLoaded === false) {
      this.fetchGroups()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.item !== prevProps.item) { this.setState({ item: this.props.item }) }

    if (this.state.item !== prevState.item) { this.fetchGroupUsers() }
  }

  fetchGroups() {
    this.props.dispatch(get('usergroup/list/withdynamicvisibilitygroup', {
      onSuccess: (response) => {
        this.setState({
          groups: response.UserGroupList,
          groupsLoaded: true
        })
      }
    }))
  }

  fetchGroupUsers() {
    if (!this.state.item || !this.state.item.UserGroupID || this.state.item.UserGroupID === '0') { return }

    this.props.dispatch(get(`usergroup/${this.state.item.UserGroupID}/user/list`, {
      onSuccess: (response) => {
        this.setState({
          users: response.UserList,
          usersLoaded: true
        })
      }
    }))
  }

  enableButton() {
    this.setState({ canSubmit: true })
  }

  disableButton() {
    this.setState({ canSubmit: false })
  }

  render() {
    const palette = this.context.muiTheme.palette
    const { language } = this.context
    const { item, groups, users } = this.state

    if (!item) { return null }

    const groupOptions = [<MenuItem
      value={false}
      key={0}
      primaryText={(item.UserGroupID === '') ? '' : language.translate('application.selectAGroup')}
    />]
    const userOptions = [<MenuItem
      value={false}
      key={0}
      primaryText={(item.UserID === '') ? '' : language.translate('application.all')}
    />]

    if (groups) {
      let userGroups = groups.filter((group) => (!group.IsOnDemand))
      let odsGroups = groups.filter((group) => (group.IsOnDemand))
      let odsGroupsGrouped = odsGroups.reduce((acc, group) => {
        const odsCompanyName = group.AccountID
        acc[odsCompanyName] = acc[odsCompanyName] || []
        acc[odsCompanyName].push(group)
        return acc
      }, {})

      userGroups.map((option) => {
        groupOptions.push(<MenuItem value={option.ID} key={option.ID} primaryText={option.GroupName} />)
      })

      if (odsGroups.length) {
        Object.keys(odsGroupsGrouped).sort().map((groupId, index) => {
          let groups = odsGroupsGrouped[groupId]

          groupOptions.push(
            <MenuItem
              style={{ color: 'rgba(0,0,0,0.6)' }}
              disabled
              value={'ODS'}
              key={`ODS-${groupId}`}
              primaryText={`-- ${language.translate('application.servicesBy')} ${groups[0].AccountName} --`} />)

          groups.map((group) => {
            groupOptions.push(<MenuItem value={group.ID} key={group.ID} primaryText={group.GroupName} />)
          })
        })
      }
    }

    if (users) {
      users.map((option) => {
        userOptions.push(
          <MenuItem
            value={option.ID}
            key={option.ID}
            primaryText={<div style={{ padding: '5px 0px 10px 10px' }}>{option.FullName}</div>}
            leftIcon={<Avatar
              src={option.ProfilePicURL}
              style={{ height: '40px', width: '40px' }}
            />}
          />)
      })
    }

    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.onCloseRequest}
      >
        <DialogTitle
          style={{
            backgroundColor: palette.headerBackgroundColor
          }}
          disableTypography
        >
          <Typography
            variant='h6'
            style={{ color: palette.alternateTextColor }}>
            {language.translate('application.defaultVisibility')}
          </Typography>
        </DialogTitle>
        <DialogContent style={{ width: '400px' }}>
          <Form onValid={this.enableButton.bind(this)} onInvalid={this.disableButton.bind(this)}>
            <FormsySelect
              name='group'
              value={item.UserGroupID || false}
              onChange={(e, value) => {
                item.UserGroupID = value
                item.UserGroup_Name = e.target.textContent

                this.setState({ item, isDirty: true }, this.fetchGroupUsers())
              }}
              floatingLabelText={language.translate('application.group')}
              validationErrors={this.context.language.messages.validationErrors}
              required
            >
              {groupOptions}
            </FormsySelect>
            {(this.state.item.UserGroupID)
              ? <FormsySelect
                name='users'
                value={this.state.item.UserID || false}
                onChange={(e, value) => {
                  item.UserID = value
                  item.User_FullName = e.target.textContent

                  this.setState({ item, isDirty: true })
                }}
                // labelStyle={{left: '-10px'}}
                floatingLabelText={language.translate('application.user')}
                validationErrors={this.context.language.messages.validationErrors}
              >
                {userOptions}
              </FormsySelect>
              : null}
            <div style={{ marginTop: '10px' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                <CancelButton
                  onClick={this.props.onCloseRequest}
                  variant='contained'
                  style={{ margin: '10px' }}
                />
                <Button
                  onClick={() => this.props.onSave(this.state.item)}
                  disabled={!this.state.canSubmit || !this.state.isDirty}
                  color='primary'
                  style={{ margin: '10px' }}
                  variant='contained'
                >
                  {language.translate('application.submit')}
                </Button>
              </div>
            </div>
          </Form>
        </DialogContent>
      </Dialog>
    )
  }
}

DefaultVisibilityEdit.propTypes = {
  item: PropTypes.object,
  onSave: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onCloseRequest: PropTypes.func.isRequired
}

DefaultVisibilityEdit.contextTypes = {
  language: PropTypes.object,
  muiTheme: PropTypes.object
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  dispatch,
  get: bindActionCreators(get, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(DefaultVisibilityEdit)
